import LoadingView from './Loading.view';
export default LoadingView;
